import { Component, OnInit } from '@angular/core';
import { SessionManager } from './session/service/session-manager';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {

  title = 'app';

  constructor(private sessionManager: SessionManager,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
  }
}
